import comp from "./GPTPlayground";
export default comp;
